import { LinkCardItem } from "../sections/LinkCardGrid";
import { handleCloseStorymap } from '../../../utils/messages';

export const cards: LinkCardItem[] = [
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                <circle cx="12" cy="9" r="2.5" />
            </svg>
        ),
        label: "About the Fund",
        title: "Find out about SKPCF",
        href: "https://www.portseattle.org/programs/south-king-and-port-communities-fund",
        accentClass: "bg-port-blue",
        iconBgClass: "bg-port-blue/10",
        iconColorClass: "text-port-blue",
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18M9 21V9" />
            </svg>
        ),
        label: "EOC Projects",
        title: "Explore EOC Current and Past Projects",
        href: "https://www.portseattle.org/programs/south-king-county-community-impact-fund-current-and-past-projects",
        accentClass: "bg-port-blue",
        iconBgClass: "bg-port-blue/10",
        iconColorClass: "text-port-blue",
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        ),
        label: "EIP Projects",
        title: "Explore EIP Current and Past Projects",
        href: "https://www.portseattle.org/page/eip-current-and-past-projects",
        accentClass: "bg-port-blue",
        iconBgClass: "bg-port-blue/10",
        iconColorClass: "text-port-blue",
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
                <path d="M12 5v14M5 12l7-7 7 7" />
            </svg>
        ),
        label: "Funding Opportunities",
        title: "Apply for Funding",
        href: "https://www.portseattle.org/skcpf-funding-opportunities",
        accentClass: "bg-[#EBB700]",
        iconBgClass: "bg-white/10",
        iconColorClass: "text-[#EBB700]",
        highlight: true,
    },
];

export const footerCards: LinkCardItem[] = [
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-7 h-7">
                <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6-3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 9m0 8V9m0 0L9 7" />
            </svg>
        ),
        label: "Interactive Map",
        title: "Explore the Map",
        // desc: "See where SKPCF investments are making a difference across South King County communities.",
        onClick: handleCloseStorymap,
        accentClass: "bg-port-blue",
        iconBgClass: "bg-port-blue/10",
        iconColorClass: "text-port-blue",
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-7 h-7">
                <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        ),
        label: "Impact Report",
        title: "Read our 5-Year Impact Report",
        // desc: "Explore five years of data, stories, and outcomes from our community investment programs.",
        href: "https://www.portseattle.org/sites/default/files/2025-08/OEDI%205-Year%20Impact%20Report-FINAL.pdf", // replace with your report URL
        accentClass: "bg-port-blue",
        iconBgClass: "bg-port-blue/10",
        iconColorClass: "text-port-blue",
    },
];